/*
 * File: QuoteIdInput.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 26 Jan 2022 4:26:23 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Input, Typography } from 'antd';
import { CreateSalesOrderType } from 'common/enums/CreateSalesOrderType';
import { useFormikContext } from 'formik';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { SalesOrderPayloadModel } from 'models/SalesOrderPayloadModel';
import { useLocation } from 'react-router-dom';
const { Title } = Typography;

const styles: InlineStylesModel = {
  formItem: {
    marginBottom: 10
  },
  formItemCol: {
    marginRight: '16px',
    maxHeight: '42px'
  },
  titleColor: {
    color: '#2F5596'
  }
};

export const QuoteIdInput = (): JSX.Element => {
  const {
    values: { quoteId, convertedFromQuote },
    handleChange
  } = useFormikContext<SalesOrderPayloadModel>();

  const { pathname } = useLocation();
  const isPosted = pathname.includes('/posted');

  return (
    <>
      <Title level={5} style={styles.titleColor}>
        {CreateSalesOrderType.QUOTE_ID}
      </Title>
      <Input disabled={isPosted || convertedFromQuote} name="quoteId" value={quoteId ?? undefined} allowClear onChange={handleChange} maxLength={30} style={styles.formItem} />
    </>
  );
};
